"use client";

import { Button } from "~/components/ui/button";
import { Download } from "lucide-react";
import { useUser } from "~/lib/user-context";
import { useNavigate } from "@remix-run/react";

interface DownloadButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "outline" | "ghost" | "destructive" | "secondary" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  downloadUrl?: string; // 实际下载链接
  scrollOnly?: boolean; // 只滚动到下载区域，不执行下载
}

export function DownloadButton({ 
  children, 
  className, 
  variant = "default", 
  size = "default",
  downloadUrl,
  scrollOnly = false
}: DownloadButtonProps) {
  const { isFullyRegistered } = useUser();
  const navigate = useNavigate();

  const handleClick = () => {
    // 如果只是滚动到下载区域（用于页面内导航）
    if (scrollOnly) {
      const downloadSection = document.getElementById('download-section');
      if (downloadSection) {
        downloadSection.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    // 如果有下载链接，需要验证登录状态
    if (downloadUrl) {
      if (!isFullyRegistered) {
        // 未登录，跳转到登录页面
        navigate('/auth/login');
        return;
      }
      
      // 已登录，执行下载
      window.open(downloadUrl, '_blank');
      return;
    }

    // 默认行为：滚动到下载区域
    const downloadSection = document.getElementById('download-section');
    if (downloadSection) {
      downloadSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Button 
      className={className}
      variant={variant}
      size={size}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
} 